import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { filtrarLineasVenta, generarLineasVenta } from '../../actions/reportes';

import { CustomValueContainer } from '../../components/react_select/ReactSelect';

const FiltrosLineasVenta = () => {

    const dispatch = useDispatch();

    const { ventana_filtros_lineas_venta } = useSelector(state => state.reportes);

    const [statusProcesar, setStatusProcesar] = useState(false);

    const [filtrosData, setFiltrosData] = useState({
        fecha_inicio: null,
        fecha_fin: null
    });

    const [columnasData, setColumnasData] = useState([]);
    const columnasDisponibles = [
        { value: 'fecha', label: 'Fecha' },
        { value: 'folio', label: 'Folio' },
        { value: 'tipo', label: 'Tipo' },
        { value: 'categoria', label: 'Categoría' },
        { value: 'subcategoria', label: 'Subcategoría' },
        { value: 'subsubcategoria', label: 'Sub-subcategoría' },
        { value: 'nombre', label: 'Nombre' },
        { value: 'cantidad', label: 'Cantidad' },
        { value: 'monto', label: 'Monto' },
        { value: 'cliente', label: 'Cliente' },
        { value: 'paciente', label: 'Paciente' },
        { value: 'medico', label: 'Médico' }
    ];

    let styles_select = {
        menuPortal: base => ({ ...base, zIndex: 9999 }),
        container: (provided, state) => ({
            ...provided
        }),
        valueContainer: (provided, state) => ({
            ...provided,
            overflow: "visible",
            marginTop: "15px"
        }),
        placeholder: (provided, state) => ({
            ...provided,
            position: "absolute",
            top: state.hasValue || state.selectProps.inputValue ? -15 : "0%",
            transition: "top 0.1s, font-size 0.1s",
            fontSize: (state.hasValue || state.selectProps.inputValue) && 13
        })
    };

    /* Filtros */
    const handleAbrir = () => { }

    const handleDatePicker = (name, value) => {
        setFiltrosData({
            ...filtrosData,
            [name]: value
        });
    }

    const handleProcesar = async (limpiar) => {
        await setStatusProcesar(true);

        if (!limpiar) {
            await dispatch(generarLineasVenta({
                ...filtrosData,
                columnas: columnasData.map(c => c.value)
            }));

            await handleCerrar();
        } else {
            let datos_base = {
                ...filtrosData,
                fecha_inicio: null,
                fecha_fin: null
            };

            await setFiltrosData(datos_base);
            await setColumnasData([]);
        }

        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if (!statusProcesar) {
            setFiltrosData({
                fecha_inicio: null,
                fecha_fin: null
            });

            setColumnasData([]);

            dispatch(filtrarLineasVenta(false));
        }
    }

    return (
        <Modal show={ventana_filtros_lineas_venta} size="lg" backdrop="static" centered onEntered={() => handleAbrir()} onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Reporte de detalle de líneas de venta</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-12 form-group mb-3">
                        <div className="input-group h-100">
                            <Select
                                name="columnas"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Columnas a incluir (vacío = todas)"
                                options={columnasDisponibles}
                                value={columnasData}
                                isClearable={true}
                                isMulti={true}
                                onChange={(value) => setColumnasData(value || [])}
                                menuPortalTarget={document.body}
                                menuPlacement="auto"
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                            />
                        </div>
                    </div>

                    <div className="col-md-6 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <DatePicker
                                    id="fecha_inicio"
                                    name="fecha_inicio"
                                    className="form-control text-center input-datepícker"
                                    dateFormat="dd/MM/yyyy"
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    selected={ filtrosData.fecha_inicio ? new Date(filtrosData.fecha_inicio) : '' }
                                    onChange={ date => handleDatePicker('fecha_inicio', date) }
                                />
                                <label className="label-datepicker" htmlFor="fecha_inicio">Fecha de inicio</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <DatePicker
                                    id="fecha_fin"
                                    name="fecha_fin"
                                    className="form-control text-center input-datepícker"
                                    dateFormat="dd/MM/yyyy"
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    selected={ filtrosData.fecha_fin ? new Date(filtrosData.fecha_fin) : '' }
                                    onChange={ date => handleDatePicker('fecha_fin', date) }
                                />
                                <label className="label-datepicker" htmlFor="fecha_fin">Fecha de fin</label>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                {
                    statusProcesar ?
                        <>
                            <button type="button" className="btn btn-secondary" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Limpiar filtros</button>
                            <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Generar reporte</button>
                        </>
                    :
                        <>
                            <button type="button" className="btn btn-secondary" onClick={() => handleProcesar(true)}><i className="fas fa-trash fa-sm"></i> Limpiar filtros</button>
                            <button type="button" className="btn btn-success" onClick={() => handleProcesar(false)}><i className="fas fa-file-excel fa-sm"></i> Generar reporte</button>
                        </>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default FiltrosLineasVenta;
